<!-- Page to view all unapproved customers-->
<!-- Verify role as Moderator -->
<ng-container *ngIf="role && role !== 'MODERATOR'">
  <h1>UNAUTHORISED ACCESS</h1> <br>
  <h3>Please Login as MODERATOR, redirecting ...</h3>
  {{unauthorised()}}
</ng-container>

<ng-container *ngIf="role && role === 'MODERATOR'">
  <div class="wrapper ">
    <br>
    <div>
      <div class="content">
        <ng-container *ngIf="!unapprovedCustomers">
          <div class="alert alert-danger" role="alert">
            No Customers to be Approved
          </div>
        </ng-container>
        <ng-container *ngIf="unapprovedCustomers">
          <div class="alert alert-danger" role="alert" *ngIf="unapprovedCustomers.length === 0">
            No Customers to be Approved
          </div>
          <div class="alert alert-primary" role="alert" *ngIf="unapprovedCustomers.length !== 0">
            Customers to be Approved
          </div>
          <!-- list of customers-->
          <div class="card">
          <div class="card-body">
            <table class="table table-hover">
              <thead class=" text-primary">
                <tr>
                  <th scope="col">Customer ID</th>
                  <th scope="col">Customer User Name</th>
                  <th scope="col">Customer Name</th>
                  <th scope="col">Customer Email</th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let unapprovedCustomer of unapprovedCustomers">
                  <td>{{ unapprovedCustomer._id }}</td>
                  <td>{{unapprovedCustomer.customerId.userName}}</td>
                  <td>{{ unapprovedCustomer.customerId.fullName }}</td>
                  <td>{{ unapprovedCustomer.customerId.email }}</td>
                  <td>
                    <button type="button" class="btn btn-success" (click)="checkThisCustomer(unapprovedCustomer)">Check this Customer</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>
<!-- end of customer list -->
